/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleChapterData } from '@INTERFACES/admin-api/chapters';

export interface PreviewChapterIntroductionTextModalState {
    isOpen: boolean;

    data: {
        canGenerateDocument: boolean;

        chapterData: AdminSingleChapterData;
    } | null;
}

export interface PreviewChapterIntroductionTextModalDispatchParams {
    canGenerateDocument: boolean;

    chapterData: AdminSingleChapterData;
}

const initialState: PreviewChapterIntroductionTextModalState = {
    isOpen: false,

    data: null,
};

export const previewChapterIntroductionTextModalSlice = createSlice({
    name: 'preview-chapter-introduction-text-modal',
    initialState,
    reducers: {
        open(state: PreviewChapterIntroductionTextModalState, action: PayloadAction<PreviewChapterIntroductionTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: PreviewChapterIntroductionTextModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
